import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Channel } from 'app/shared/models/channel.model';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  @ViewChild('vform') validationForm: FormGroup;

  channelForm:FormGroup
  channelFormSubmitted:boolean=false;
  channelList=[]
  channel_cat_id='63f89909c3648e0879c3e05a'
  selectedCat=null
  isEdit:boolean=false
  channel=new Channel()
  currentUrl:any

  technology_catId='6319d5025ab9e462a96cfbba'
  technology_List=[]
  selectedTechnology=null

  constructor(private formBuilder:FormBuilder,
              private apiService:ApiService,
              private router:Router,public toastr: ToastrService,
              private session: SessionStorageService,
              private activerouter:ActivatedRoute) { 
                this.currentUrl = this.activerouter.snapshot.routeConfig.path
                console.log('currentUrl=>>', this.currentUrl)
                if(this.currentUrl !=='add'){
                  let value = session.getObject('channel-data')
                  if(value!=null){
                    this.channel = value;
                    this.isEdit = true;
                  }     
                }
              }

  ngOnInit(): void {
    this.channelForm=this.formBuilder.group({
      name: ['', Validators.required],
      category: ['',],
      notes: ['',],
      admin_notes: ['',],
    })
    this.getChannels()
    this.getTechnologyList()
    if(this.channel._id){
      this.getChannelByIdd()
    }
  }
  get rf(){
    return this.channelForm.controls
  }
  getChannelByIdd(){
    this.apiService.getChannelById(this.channel._id).subscribe((res:any)=>{
      this.selectedCat=res?.data?.category?._id
      this.selectedTechnology=res?.data?.technology?._id
    })
  }
  getChannels() {
    this.apiService.getTagByTagCatgoryId(this.channel_cat_id).subscribe((res: any) => {
      this.channelList = res.data
      this.selectedTechnology=res?.data?.technology
    })
  }
  getCategoryId(event){
    this.selectedCat
    if(this.channel._id){
      this.channel.category._id=this.selectedCat
    }
  }
  getTechnologyList(){
    this.apiService.getTagByTagCatgoryId(this.technology_catId).subscribe((res:any)=>{
      this.technology_List=res.data.slice(0, 4)
    })
   }
   getTechnologyId(event){
    this.selectedTechnology
   }
  submit(){
    let body={
      name: this.channelForm.value.name,
      category: this.selectedCat,
      notes: this.channelForm.value.notes,
      admin_notes: this.channelForm.value.admin_notes,
      technology:this.selectedTechnology
    }
    console.log('body',body)
    this.apiService.createChannel(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Created Successfully')
        this.router.navigate(['/channel/list'])    
       }
     else{this.toastr.error(res.error)}
    })
  }
  update(){
    this.channel.category=this.selectedCat
    this.channel.technology=this.selectedTechnology
    this.apiService.updateChannel(this.channel._id,this.channel).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Updated Successfully')
        this.router.navigate(['/channel/list'])    
       }
     else{this.toastr.error(res.error)}
    })
  }
  back(){
    this.router.navigate(['/channel/list'])
  }
}
